<template>
  <div id="addDepart">
    <el-dialog
      :title="title"
      :visible.sync="addVisible"
      width="679px"
      :before-close="handleClose"
    >
      <el-form ref="form" :rules="rules" class="addForm" :model="addForm" label-width="105px">
        <el-form-item label="层级名称：">
          <el-input v-model="selectTree.FLevelName" disabled />
        </el-form-item>
        <el-form-item label="部门名称：" prop="FName">
          <el-input v-model="addForm.FName" placeholder="请输入部门名称（20字以内）" maxlength="20" />
        </el-form-item>
        <el-form-item label="所属公司：">
          <el-input v-model="selectTree.FDemandUnitName" disabled />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="close_btn" @click="handleClose">取 消</el-button>
        <el-button class="confirm_btn" type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import service from '@/utils/request'
export default {
  props: {
    addVisible: {
      type: [Boolean]
    },
    selectTree: {
      type: [Object, Number],
      default: () => {}
    },
    title: {
      type: [String],
      default: ''
    }
  },
  data() {
    return {
      addForm: {
        FName: ''
      },
      rules: {
        FName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' },
          { max: 15, message: '请输入15字以内的部门名称', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    addVisible(val) {
      if (val && this.title === '修改部门') {
        this.addForm.FName = this.selectTree.FName
      }
    }
  },
  methods: {
    handleClose() {
      this.addForm.FName = ''
      this.$refs.form.clearValidate()
      this.$emit('addSwitch', false)
    },
    confirm() {
      //   this.$emit('addSwitch', true)
      this.$refs.form.validate(valid => {
        if (valid) {
          const loadingObj = this.$loading({
            lock: true,
            text: '提交中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0,0,0,0.5)',
            target: document.querySelector('.submit-test-dialog')
          })
          const params = new URLSearchParams()
          const jsonObj = {
            ...this.addForm
          }
          let url = ''
          if (this.title === '新增部门') {
            url = '/mall/mallmanage/demanddepart/insertDemanddepart'
            jsonObj.FParentID = this.selectTree.FID
          } else {
            url = '/mall/mallmanage/demanddepart/modifyDemanddepart'
            jsonObj.FID = this.selectTree.FID
          }
          params.append('jsonStr', JSON.stringify(jsonObj))
          service({
            url,
            method: 'post',
            params
          })
            .then(res => {
              this.addForm.FName = ''
              loadingObj.close()
              if (res.result) {
                this.$message.success(res.msg)
              } else {
                this.$message.error(res.msg)
              }
              this.$emit('addSwitch', true)
            })
            .catch(() => {
              loadingObj.close()
            })
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
#addDepart {
    .dialog-footer {
        .close_btn {
            border: 1px solid #C4CBD7;
            color: #C4CBD7;
        }
    }
}
</style>
<style lang='scss'>
#addDepart {
    .el-dialog {
        position: relative;
        top: 45% !important;
        height: 518px;
        border-radius: 10px;
    }
    .el-dialog__header {
        height: 40px;
        font-size: 16px;
        padding-left: 23px;
        border-radius: 10px 10px 0 0;
    }
    .el-dialog__body {
        height: 405px;
        padding: 36px 107px;
        border-bottom: 1px solid #C4CBD7;
    }
    .el-dialog__footer {
        display: flex;
        align-items: center;
        justify-content: right;
        height: 73px;
        padding: 0;
        padding-right: 35px;
    }
    .dialog-footer {
        .el-button {
            width: 80px;
            height: 36px;
        }
    }
    .addForm {
        .el-form-item__label {
            font-size: 16px !important;
            color: #676871;
        }
    }
}
</style>
